export default {
  'get-list': {
    method: 'post',
    url: '/order/request/list'
  },
  add: {
    method: 'post',
    url: '/order/request'
  },
  delete: {
    method: 'delete',
    url: '/order/request'
  },
  update: {
    method: 'put',
    url: '/order/request/ID'
  },
  changeStatus: {
    method: 'put',
    url: '/order/request/status'
  },
  select: {
    method: 'get',
    url: '/order/request/find?key=KEY'
  }
}
